var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { agent, office, listing_provider, property_type, builder, data_provider } = options; 
__p+='\n\n<div class="row">\n';
 if (property_type == 'for_sale') { 
__p+='\n  ';
 if( agent || office) { 
__p+='\n    <div class="col-qv-xs-12 col-qv-sm-6">\n      ';
 if (agent) { 
__p+='\n        <div class="margin-bottom clearfix component_business-card business-card-agent '+
((__t=( (agent.photo_attribution.photo || office.details.photo) ? '' : 'businesscard-offset' ))==null?'':__t)+
'">\n          ';
 if(agent.photo_attribution.photo) { 
__p+='\n            <div class="media">\n              <div class="media-img-wrapper">\n                <img alt="'+
((__t=( agent.photo_attribution.slogan ))==null?'':__t)+
'" class="absolute-centering" data-src="'+
((__t=( agent.photo_attribution.photo ))==null?'':__t)+
'">\n              </div>\n            </div>\n          ';
 } 
__p+='\n          <div class="content">\n            <ul class="list-default list-unstyled">\n                ';
 if(agent.details.name) { 
__p+='\n                  <li>Presented by: </li>\n                  <li>\n                    ';
 if(agent.details.show_realtor_logo) { 
__p+='\n                      REALTOR<sup>&reg;</sup>\n                    ';
 } 
__p+='\n                    ';
 if(agent.details.link) { 
__p+='\n                      <a target="_blank" data-omtag="ldp:listingProvider:agentProfile" data-label="additional-agent-name" href="'+
((__t=( agent.details.link ))==null?'':__t)+
'">\n                          '+
((__t=( agent.details.name ))==null?'':__t)+
'\n                      </a>\n                    ';
 } else { 
__p+='\n                      '+
((__t=( agent.details.name ))==null?'':__t)+
'\n                    ';
 } 
__p+='\n                    ';
 if(agent.details.show_realtor_logo) { 
__p+='\n                      <a rel="popover" href="javascript:void(0)" data-placement="top" data-popover-content="#popover-realtor-block" aria-label="realtor popover">\n                        <i class="ra ra-block-r icon-realtor-block"></i>\n                      </a>\n                      <div id="popover-realtor-block" class="hide">\n                        <p class="realtor-block-text font-size-small no-margin">\n                          A REALTOR<sup>&reg;</sup> is a real estate professional\n                          who is a member of the NATIONAL ASSOCIATION OF REALTORS<sup>&reg;</sup>\n                          and subscribes to its strict code of ethics.\n                        </p>\n                      </div>\n                    ';
 } 
__p+='\n                  </li>\n                ';
 } 
__p+='\n\n                ';
 if(agent.details.phone) { 
__p+='\n                  <li class="link-secondary">\n                    <span class="visible-sm-inline visible-md-inline visible-lg-inline" data-label="additional-agent-phone">\n                      '+
((__t=( agent.details.phone ))==null?'':__t)+
'\n                    </span>\n                    <span class="visible-xxs-inline visible-xs-inline" data-label="additional-agent-phone-mobile">\n                      <a href="'+
((__t=( `tel:${agent.details.phone}` ))==null?'':__t)+
'" class="phone-tracking" data-phone-number="'+
((__t=( agent.details.phone ))==null?'':__t)+
'">\n                        '+
((__t=( agent.details.phone ))==null?'':__t)+
'\n                      </a>\n                    </span>\n                  </li>\n                ';
 } 
__p+='\n            </ul>\n          </div>\n        </div>\n      ';
 } 
__p+='\n      ';
 if(office) { 
__p+='\n        <div class="margin-bottom clearfix component_business-card business-card-lg '+
((__t=( (agent.photo_attribution.photo || office.details.photo) ? '' : 'businesscard-offset' ))==null?'':__t)+
'">\n          ';
 if(office.details.photo) { 
__p+='\n            <div class="media">\n              <div class="media-img-wrapper">\n                <img alt="This listing is presented by '+
((__t=( office.details.name ))==null?'':__t)+
'" class="absolute-centering" data-src="'+
((__t=( office.details.photo ))==null?'':__t)+
'">\n              </div>\n            </div>\n          ';
 } 
__p+='\n          <div class="content">\n            <ul class="list-default list-unstyled">\n              ';
 if(office.details.name) {
__p+='\n                <li>Brokered by:</li>\n                ';
 if (office.details.link) { 
__p+='\n                  <li data-label="additional-office-link">\n                    <a href="'+
((__t=( office.details.link ))==null?'':__t)+
'" target="_blank" data-omtag="ldp:listingProvider:brokerSite">\n                    '+
((__t=( office.details.name ))==null?'':__t)+
'<i class="ra ra-external-link icon-space-left"></i>\n                    </a>\n                  </li>\n                ';
 } else { 
__p+='\n                  <li data-label="additional-office-name">\n                    '+
((__t=( office.details.name ))==null?'':__t)+
'\n                  </li>\n                ';
 } 
__p+='\n              ';
 } 
__p+='\n              ';
 if(office.details.phone) { 
__p+='\n                <li class="link-secondary">\n                  <span class="visible-sm-inline visible-md-inline visible-lg-inline" data-label="additional-office-phone">\n                    '+
((__t=( office.details.phone ))==null?'':__t)+
'\n                  </span>\n                  <span class="visible-xxs-inline visible-xs-inline" data-label="additional-office-phone">\n                    <a href="'+
((__t=( `tel:${office.details.phone}` ))==null?'':__t)+
'" class="phone-tracking" data-phone-number="'+
((__t=( office.details.phone ))==null?'':__t)+
'">\n                    '+
((__t=( office.details.phone ))==null?'':__t)+
'\n                    </a>\n                  </span>\n                </li>\n              ';
 } 
__p+='\n            </ul>\n          </div>\n        </div>\n      ';
 } 
__p+='\n    </div>\n  ';
 } 
__p+='\n  ';
 if (listing_provider) { 
__p+='\n      <div class="col-qv-xs-12 col-qv-sm-6">\n        <div id="listing-provider-info" class="listing-section-provider ">\n          <table class="table table-noheader table-provider">\n            <tbody>\n              ';
 if(listing_provider.broker_location) { 
__p+='\n              <tr data-label="Broker Location">\n                <td class="col-provider-lbl">Broker Location:</td>\n                <td>'+
((__t=( listing_provider.broker_location ))==null?'':__t)+
'</td>\n              </tr>\n              ';
 } 
__p+='\n              ';
 if(listing_provider.mls_name) { 
__p+='\n              <tr data-label="Data Source">\n                <td class="col-provider-lbl">Data Source:</td>\n                <td>'+
((__t=( listing_provider.mls_name ))==null?'':__t)+
'</td>\n              </tr>\n              ';
 } 
__p+='\n              ';
 if(listing_provider.mls_id) { 
__p+='\n              <tr data-label="Source Property ID">\n                <td class="col-provider-lbl">Source&#39;s Property ID:</td>\n                <td itemprop="productID">'+
((__t=( listing_provider.mls_id ))==null?'':__t)+
'</td>\n              </tr>\n              ';
 } 
__p+='\n              ';
 if(listing_provider.mls_copy_right) { 
__p+='\n              <tr data-label="Data Source Copyright">\n                <td class="col-provider-lbl">Data Source Copyright:</td>\n                <td>'+
((__t=( listing_provider.mls_copy_right ))==null?'':__t)+
'</td>\n              </tr>\n              ';
 } 
__p+='\n            </tbody>\n          </table>\n        </div>\n      </div>\n    ';
 } 
__p+='\n';
 } else if(property_type == 'new_plan') { 
__p+='\n  ';
 if(builder) { 
__p+='\n    <div class="col-qv-xs-12 col-qv-sm-6">\n      <div class="clearfix component_business-card business-card-lg '+
((__t=(  builder.photo? '' : 'businesscard-offset' ))==null?'':__t)+
'">\n        ';
 if(builder.photo) {
__p+='\n          <div class="media">\n            <div class="media-img-wrapper">\n              <img alt="This listing is presented by '+
((__t=( builder.name ))==null?'':__t)+
'" data-src="'+
((__t=( builder.photo ))==null?'':__t)+
'" class="absolute-centering">\n            </div>\n          </div>\n        ';
 } 
__p+='\n        <div class="content">\n          <ul class="list-default list-unstyled">\n            ';
 if(builder.name) { 
__p+='\n              <li>Built by:</li>\n              ';
 if (builder.site) { 
__p+='\n                <li data-label="additional-office-link">\n                  <a href="'+
((__t=( builder.site ))==null?'':__t)+
'" target="_blank" data-omtag="ldp:listingProvider:brokerSite">\n                  '+
((__t=( builder.name ))==null?'':__t)+
' at\n                  </a>\n                </li>\n              ';
 } else { 
__p+='\n                <li data-label="additional-office-name">\n                  '+
((__t=( builder.name ))==null?'':__t)+
'\n                </li>\n              ';
 } 
__p+='\n            ';
 } 
__p+='\n            ';
 if(builder.builder_agent) { 
__p+='\n               <li data-label="additional-sales-associate">\n                 Sales Associates:\n                 <span class="display-block">'+
((__t=( builder.builder_agent ))==null?'':__t)+
'</span>\n               </li>\n            ';
 } 
__p+='\n            ';
 if(builder.phone) { 
__p+='\n              <li class="link-secondary">\n                <span class="visible-sm-inline visible-md-inline visible-lg-inline" data-label="additional-office-phone">\n                  '+
((__t=( builder.phone ))==null?'':__t)+
'\n                </span>\n                <span class="visible-xxs-inline visible-xs-inline" data-label="additional-office-phone">\n                  <a href="'+
((__t=( `tel:${builder.phone}` ))==null?'':__t)+
'" class="phone-tracking" data-phone-number="'+
((__t=( builder.phone ))==null?'':__t)+
'">\n                  '+
((__t=( office.details.phone ))==null?'':__t)+
'\n                  </a>\n                </span>\n              </li>\n            ';
 } 
__p+='\n            ';
 if(builder.builder_office_hours) { 
__p+='\n              <li>\n                Hours: '+
((__t=( builder.builder_office_hours ))==null?'':__t)+
'\n              </li>\n            ';
 } 
__p+='\n          </ul>\n        </div>\n      </div>\n    </div>\n  ';
 } 
__p+='\n  ';
 if (data_provider) { 
__p+='\n    <div class="col-qv-xs-12 col-qv-sm-6">\n      <div id="listing-provider-info" class="listing-section-provider ">\n        <table class="table table-noheader table-provider">\n          <tbody>\n            ';
 if(data_provider.name) { 
__p+='\n            <tr data-label="Broker Location">\n              <td class="col-provider-lbl">Data Source:</td>\n              <td>'+
((__t=( data_provider.source || data_provider.name ))==null?'':__t)+
'</td>\n            </tr>\n            ';
 } 
__p+='\n            ';
 if(data_provider.id) { 
__p+='\n            <tr data-label="Data Source">\n              <td class="col-provider-lbl">Source&#39;s Property ID:</td>\n              <td>'+
((__t=( data_provider.id ))==null?'':__t)+
'</td>\n            </tr>\n            ';
 } 
__p+='\n          </tbody>\n        </table>\n      </div>\n    </div>\n  ';
 } 
__p+='\n';
 } 
__p+='\n</div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-additional-info.jst.ejs